import Invoices              from 'scripts/defa/invoices/collection-invoices';
import Usages                from 'scripts/defa/invoices/collection-usages';
import Invoice               from 'scripts/defa/invoices/model-invoice';
import Usage                 from 'scripts/defa/invoices/model-usage';
import InvoiceCollectionView from 'scripts/defa/invoices/view-invoice-collection-view';
import InvoiceContainer      from 'scripts/defa/invoices/view-invoice-container';
import InvoiceSnippet        from 'scripts/defa/invoices/view-invoice-snippet';
import InvoiceUpdateForm     from 'scripts/defa/invoices/view-invoice-update-form';
import UsageCreateForm       from 'scripts/defa/invoices/view-usage-create-form';
import Module                from 'scripts/module';

const InvoiceModule = new Module( 'InvoiceModule', {
	views      : {
		UsageCreateForm,
		InvoiceUpdateForm,
		InvoiceSnippet,
		InvoiceContainer,
		InvoiceCollectionView
	},
	models     : {
		Usage,
		Invoice
	},
	collections: {
		Usages,
		Invoices
	}
} );

export default InvoiceModule;